<template>
    <div class="coupons-home" v-if="coupons" :style="{order:h5ConfigDetails[0]['modalOrder']['CouponsHomeOrder'][0]}">
      <img class="bg" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${pictures['bg'][0]}`" alt="">
      <div :class="`coupon-wrapper conpon-style${h5ConfigDetails[0]['couponReceive']['showStyle'][0]}`">
        <div class="coupon-item" v-for="(coupon, idx) in coupons" :key="idx">
          <img class="coupon-bg" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${coupon.bgImg}`" alt="">
          <img class="coupon-btn" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${coupon.status === FREE_BTN_STATUS.RECEIVED ? pictures['received-btn'][0] 
            : (coupon.status === FREE_BTN_STATUS.FINISH ? pictures['receive-over-btn'][0] : pictures[FREE_BTN_IMG[coupon.status]][0])}`" 
            @click="_click_free_btn(coupon)" alt="">
          <div v-if="coupon.taskId && coupon.status === FREE_BTN_TYPE[4]" class="task-times">已观看：{{ completedTimes }}/{{ allTimes }}</div>
        </div>
      </div>

      <!-- 礼包领取模块中奖弹窗 -->
      <multiple-prize-winning ref="multiplePrizeWinning"></multiple-prize-winning>

      <confirm-modal></confirm-modal>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import store from '@/store/index'
import { baseUrl } from '@/config/env'
import appBridge from '@/config/appBridge'
import { postCouponByCouponId, postTaskByTaskId } from '@/service/apis'
import MultiplePrizeWinning from '@/components/modal/MultiplePrizeWinning'
import ConfirmModal from '@/components/liveLink/ConfirmModal'

export default {
  name: 'CouponsHome',
  props: ['loginFn'],
  components: { MultiplePrizeWinning, ConfirmModal },
  data () {
    return {
      baseUrl,
      coupons: null,
      pictures: null,
      FREE_BTN_IMG: Object.freeze({// 对应按钮图片名称 
        RECEIVE: 'receive-btn', 
        TOBUY: 'toBuyBtn', 
        TOSHARE: 'toShareBtn', 
        TOACCEL: 'toAccelBtn',
        TOWATCH: 'toWatchBtn',
        LIVELINK: 'receive-btn'
      }),
      FREE_BTN_TYPE: ['RECEIVE', 'TOBUY', 'TOSHARE', 'TOACCEL', 'TOWATCH', 'LIVELINK'],
      FREE_BTN_STATUS: Object.freeze({
        RECEIVED: 'received', // 已领取 （礼包该用户领取完了）
        FINISH: 'finish' // 已领完 （礼包发完了，该用户没领到）
      }), 
      buyProductFlag: [],
      product: null,
      completedTimes: 0,
      allTimes: 0
    }
  },
  mounted () {
    this.pictures = this.h5ConfigDetails[0].couponReceivePicture
    if (!this.isLogin) {
      this._create_coupons()
    }
  },
  methods: {
    // 当前逻辑只处理了总量礼包，不包括每日礼包和加速，分享等任务性质的礼包
    _create_coupons () {
      const data = this.h5ConfigDetails[0].couponReceive
      this.coupons = data['coupon-pic'].map((ele, idx) => {
        if(Number(data['coupon-type'][idx]) === 4){  //视频走任务逻辑
          const couponId = data['coupon-id'][idx]
          const taskId = this.isInIos? data['taskIdIos'][0] : data['taskIdAndroid'][0]
          const task = this.taskList ? this.taskList.find((task) => {
            return task.taskId === taskId
          }) : null
          
          if(task){
            this.completedTimes = task.taskProgress.length
            this.allTimes = Number(Object.keys(task.checkPoints)[0])
          }
          let taskStatus
          let finishStatus = this.couponList && this.couponList.couponList ? this.couponList.couponList.find((p) => {
            return p.couponId == couponId
          }) : null
          if(finishStatus && (finishStatus.usedAmount == finishStatus.totalAmount)){
            taskStatus = this.FREE_BTN_STATUS.FINISH
          } else if(task && (this.completedTimes < this.allTimes)) {
            taskStatus = this.FREE_BTN_TYPE[Number(data['coupon-type'][idx])]
          } else {
            const isReceived = this.couponsHistory ? this.couponsHistory.exchangeHistoryList.find((his) => {
              return his.couponId === couponId
            }) : null
            if (isReceived && !(isReceived.couponStatus === 0 || isReceived.couponStatus === 3)){
              taskStatus = this.FREE_BTN_STATUS.RECEIVED
            } else if(isReceived && (isReceived.couponStatus === 0 || isReceived.couponStatus === 3)){
              taskStatus = this.FREE_BTN_TYPE[0]
            }  else {
              taskStatus = this.FREE_BTN_TYPE[Number(data['coupon-type'][idx])]
            }
          }
          return {
            idx,
            couponId: couponId,
            bgImg: ele, // 每条的img config
            status: taskStatus, // 礼包状态
            taskId: taskId
          }
        } else {
          const couponId = data['coupon-id'][idx]
          const taskId = data['task-id'][idx]
          const isReceived = this.couponsHistory ? this.couponsHistory.exchangeHistoryList.find((his) => {
            return his.couponId === couponId
          }) : null
          let finishStatus = this.couponList && this.couponList.couponList ? this.couponList.couponList.find((p) => {
            return p.couponId == couponId
          }) : null
          return {
            idx,
            couponId: couponId,
            taskId,
            bgImg: ele, // 每条的img config
            status: (isReceived && !(isReceived.couponStatus === 0 || isReceived.couponStatus === 3)) ? this.FREE_BTN_STATUS.RECEIVED : ((isReceived && (isReceived.couponStatus === 0 || isReceived.couponStatus === 3)) ? this.FREE_BTN_TYPE[0] : (finishStatus && (finishStatus.usedAmount == finishStatus.totalAmount) ? this.FREE_BTN_STATUS.FINISH : this._calc_btn_status(data, idx))), // 礼包状态
          }
        }
      })
    },
    _calc_btn_status(data, idx) {
      let status
      let task
      switch (Number(data['coupon-type'][idx])) {
        case 2: //分享
          store.commit('SET_SHARE_COUPON_ID', data['coupon-id'][idx])
          // 分享结束后等待触发
          window.eventBus.$on('onCouponResult', async (isSuccess, couponId) => {
            // 分享失败情况
            if (!isSuccess) {
              this.$toast('分享失败，请稍后重试')
              return
            }
            
            const res = await postCouponByCouponId(this.userInfo.userId, couponId)

            // 分享成功后礼包兑换失败情况
            if (res.resultCode !== 0) {
              this.$sensors.track('app_page_click', {module_name: 'gift_bag', floor_number: idx, click_result: 'fail'})
              this.$toast('任务完成失败，请稍后重试！')
              return
            }

            window.eventBus.$emit('refreshAfterPay')
            this.$sensors.track('app_page_click', {module_name: 'gift_bag', floor_number: idx, click_result: 'success'})
            this.$toast('任务成功，快去领奖吧！')
          })
          status = 'TOSHARE'
          break;
        case 5:
          task = this.taskList.find(ele => ele.taskId === data['task-id'][idx])
          status = task ? (task.completedTimes < task.allTimes ? this.FREE_BTN_TYPE[Number(data['coupon-type'][idx])] : this.FREE_BTN_STATUS.RECEIVED) : 
            this.FREE_BTN_TYPE[Number(data['coupon-type'][idx])]
          break
        default:
          status = this.FREE_BTN_TYPE[Number(data['coupon-type'][idx])]
          break;
        }
      return status
    },
    // 点击总量礼包逻辑
    _click_free_btn (coupon) {
      if (!this.isLogin) {
        return this.loginFn()
      }

      if (this.llkSwitchOn && !this.isBinded) {
        this.$toast('请先绑定游戏账号', 3000)
        return
      }

      const activitySetting = this.h5ConfigDetails[0].activitySetting
      switch (coupon.status) {
        case this.FREE_BTN_TYPE[0]:
          this.$sensors.track('app_page_click', {module_name: 'gift_bag', floor_number: coupon.idx})

          this._request_coupon(coupon, (couponDescription) => {
            coupon.status = this.FREE_BTN_STATUS.RECEIVED
            // 弹中奖弹窗
            this.$refs.multiplePrizeWinning.show(couponDescription)
          })
          break;
        case this.FREE_BTN_TYPE[1]:
          this.$sensors.track('app_page_click', {module_name: 'gift_bag', floor_number: coupon.idx, button_name: 'buy_vip'})
          this.buyProductFlag = this.h5ConfigDetails[0]['couponReceive']['buyProductFlag']
          if (this.buyProductFlag && this.buyProductFlag[0].indexOf(',') === -1) {
            this.product = this.$store.state.productList.filter(p => {
              return Number(p.flag) === Number(this.buyProductFlag[coupon.idx])
            })[0]
            if (this.product) {
              appBridge.startPay(this.product, this.userInfo)
              window.eventBus.$emit('payInH5', this.product, false)
            } else {
              this.$parent.$refs.payPanelBottom.show()
            }
          } else {
            this.$parent.$refs.payPanelBottom.show()
          }
          break;
        case this.FREE_BTN_TYPE[2]:
          this.$sensors.track('app_page_click', {module_name: 'gift_bag', floor_number: coupon.idx, button_name: 'share'})
          
          appBridge.shareByApp(activitySetting.shareTitle[0], activitySetting.shareContent[0], activitySetting.shareIcon[0], window.location.href)
          break;
        case this.FREE_BTN_TYPE[3]:
          this.$sensors.track('app_page_click', {module_name: 'gift_bag', floor_number: coupon.idx, button_name: 'accel'})

          if (!appBridge.isInstallGame(activitySetting.packageNameAndroid[0])) {
            this.$toast('请先安装该游戏')
            return
          }
          appBridge.finishTask(coupon.taskId, 17)
          break;
        case this.FREE_BTN_TYPE[4]:
          this.$sensors.track('app_page_click', {module_name: 'gift_bag', floor_number: coupon.idx, button_name: 'watch'})
          appBridge.finishTask(coupon.taskId, 22)
          break;
        case this.FREE_BTN_TYPE[5]:
          this._process_livelink_task(coupon)
          break
      }
    },
    // 点击livelink登录任务得处理流程
    async _process_livelink_task (coupon) {
      try {
        let taskRes = await postTaskByTaskId(this.userInfo.userId, coupon.taskId)
        if (taskRes.resultCode === 0) {
          this.$sensors.track('app_page_click', {module_name: 'gift_bag', button_name: 'log_misson', click_result: 'success'})

          coupon.status = this.FREE_BTN_STATUS.RECEIVED
        } else {
          this.$sensors.track('app_page_click', {module_name: 'gift_bag', button_name: 'log_misson', click_result: 'fail'})

          this.$toast('请您登录游戏后领取', 3000)
        }
      } catch (error) {
          this.$sensors.track('app_page_click', {module_name: 'gift_bag', button_name: 'log_misson', click_result: 'fail'})

        // 实际接口未登录返回是这样的
        if (error.error && error.error.indexOf('error code: 0') > 0) {
          this.$toast('请您登录游戏后领取', 3000)
          return
        }
        this.$toast('领取失败，请稍后重试！', 3000)
      }
    },
    async _request_coupon (coupon, callback) {
      const couponId = coupon.couponId
      try {
        const res = await postCouponByCouponId(this.userInfo.userId, couponId)
        const couponInfo = this.couponList.couponList.find((coupon) => {
          return coupon.couponId === couponId
        })
  
        if (res.resultCode !== 0) {
          this.$sensors.track('app_page_click', {module_name: 'gift_bag', floor_number: coupon.idx, click_result: 'fail'})

          this.$toast('兑换失败，请稍后重试！', 3000)
          return
        }
  
        this.$sensors.track('app_page_click', {module_name: 'gift_bag', floor_number: coupon.idx, click_result: 'success'})
        callback(couponInfo.couponDescription)
      } catch (error) {
        if (error.resultCode === 139 || error.resultCode === 138) {
          this.$toast('礼包已发完，感谢参与！', 3000)
          coupon.status = this.FREE_BTN_STATUS.FINISH
          return
        } else {
          this.$parent.$refs.errorWin.show(`${global.ERROR_INTERFACE_POSTCOUPON}-${error.message}`)
        }
      }
    }
  },
  computed: {
    ...mapState(['productList', 'h5ConfigDetails', 'h5ConfigImgPath', 'couponsHistory', 'userInfo', 'couponList', 'isLogin', 'taskList', 'isInIos', 'llkSwitchOn']),
    ...mapGetters([
      'isBinded'
    ]),
    isOnCheange({couponList, taskList}){ //任何礼包或任务更新时 进行数据更新
      return {couponList, taskList}
    }
  },
  watch: {
    isOnCheange: function () {
      this._create_coupons()
    }
  }
}
</script>

<style scoped lang="less">
  .coupons-home {
    position: relative;
    font-size: 0;
  }

  .bg {
    width: 100%;
    height: auto;
    display: block;
  }

  .coupon-item {
    width: 100%;
    position: relative;
    font-size: 0;
    // margin-bottom: 1.2rem;
  }

  .coupon-bg {
    width: 100%;
  }

  .coupon-btn {
    width: 9rem;
    position: absolute;
    right: 2rem;
    top: 3rem;
  }
  .task-times {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    width: 9rem;
    position: absolute;
    right: 2rem;
    top: 6rem;
    font-size: 1rem;
    color: #fff;
    text-align: center;
  }

  .coupon-wrapper {
    position: absolute;
    top: 0;
    right: 0;
    .coupon-btn {
      width: 9.1rem;
      position: absolute;
      right: 1.7rem;
      top: 2.7rem;
    }
    // height: calc(100% - 4.1rem);
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    // justify-content: space-around;
  }
  .conpon-style1{
    padding-top: 4.1rem;
    .coupon-btn {
      width: 9.1rem;
      position: absolute;
      right: 1.7rem;
      top: 2.7rem;
    }
  }
  .conpon-style2{
    .coupon-btn {
      width: 18rem;
      position: absolute;
      bottom: 2.7rem;
      left: 0;
      right: 0;
      margin: auto;
      top: unset;
    }
  }
  .conpon-style3{
    padding-top: 1.67rem;
    .coupon-btn {
      width: 15.63rem;
      position: absolute;
      bottom: 1.67rem;
      left: 0;
      right: 0;
      margin: auto;
      top: unset;
    }
  }
  .conpon-style4{
    padding-top: 1.67rem;
    .coupon-btn {
      width: 12.47rem;
      position: absolute;
      bottom: 1.67rem;
      right: 1.33rem;
      top: unset;
    }
  }
</style>
